'use client';

import { normalizeIdentityNumber } from '@/lib/identityNumber';
import { Input } from '@holistic/components';

type IdentityNumberFieldProps = {
  value: string;
  onChange: (v: string) => void;
  error: string | null;
};

const IdentityNumberField = ({
  value,
  onChange,
  error,
}: IdentityNumberFieldProps) => (
  <div className="flex flex-col gap-2">
    <div className="flex items-baseline justify-between gap-4">
      <label className="text-sm font-medium text-gray-700">
        T.C. Kimlik Numarası <span className="text-red-500">*</span>
      </label>
    </div>

    <Input
      value={value}
      onChange={(e) => onChange(normalizeIdentityNumber(e.target.value))}
      placeholder="11 haneli T.C. Kimlik No"
      maxLength={11}
      inputMode="numeric"
      className="font-mono"
      error={error ?? undefined}
    />

    {!error && (
      <p className="text-xs leading-relaxed text-gray-400">
        Faturalandırma ve servis kayıt işlemleri için 11 haneli T.C. Kimlik
        Numaranız zorunludur.
      </p>
    )}
  </div>
);

export default IdentityNumberField;
